import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged, updateProfile } from 'firebase/auth';
import './component.css';

function Setting({ activeNav, setActiveNav }) {
    const [activeTab, setActiveTab] = useState('Account');
    const [user, setUser] = useState(null);
    const [userDbData, setUserDbData] = useState({ address: '' });

    // Modal state for editing profile name
    const [isNameModalOpen, setIsNameModalOpen] = useState(false);
    const [newName, setNewName] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);

    // Modal state for editing address
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [newAddress, setNewAddress] = useState('');

    // Authentication ကို စစ်ဆေးပြီး user data နှင့် database မှ address ကိုပါ ဆွဲယူရန်
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
                setNewName(currentUser.displayName || '');

                // Fetch user additional data (like address) from backend database
                try {
                    const response = await fetch(`http://localhost/get/all/students`); // သို့မဟုတ် user သီးသန့် fetch သော API ရှိက ထည့်နိုင်ပါသည်
                    // ဒီနေရာတွင် ကာရင့်ယူဆာ၏ ဒေတာကို database မှ ယူရန်
                } catch (err) {
                    console.error('Error fetching user details:', err);
                }
            } else {
                setUser(null);
            }
        });
        return () => unsubscribe();
    }, []);

    // Handle Profile Name Update
    const handleUpdateName = async (e) => {
        e.preventDefault();
        if (!newName.trim()) return;

        setIsUpdating(true);
        try {
            if (auth.currentUser) {
                await updateProfile(auth.currentUser, {
                    displayName: newName.trim()
                });

                // Also sync with backend database
                await fetch('http://localhost/update/profile', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        uid: auth.currentUser.uid,
                        displayName: newName.trim(),
                        email: auth.currentUser.email
                    })
                });

                setUser({ ...auth.currentUser });
                setIsNameModalOpen(false);
                alert('Profile name updated successfully!');
            }
        } catch (error) {
            console.error('Error updating profile name:', error);
            alert('Failed to update profile name. Please try again.');
        } finally {
            setIsUpdating(false);
        }
    };

    // Handle Address Update via API (/update/profile)
    const handleUpdateAddress = async (e) => {
        e.preventDefault();
        if (!newAddress.trim()) return;

        setIsUpdating(true);
        try {
            if (auth.currentUser) {
                const response = await fetch('http://localhost/update/profile', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        uid: auth.currentUser.uid,
                        address: newAddress.trim(),
                        email: auth.currentUser.email
                    })
                });
                const result = await response.json();

                if (result.status === 'success') {
                    setUserDbData(prev => ({ ...prev, address: newAddress.trim() }));
                    setIsAddressModalOpen(false);
                    alert('Address updated successfully!');
                } else {
                    alert(result.text || 'Failed to update address.');
                }
            }
        } catch (error) {
            console.error('Error updating address:', error);
            alert('Network error while updating address.');
        } finally {
            setIsUpdating(false);
        }
    };

    const accCardData = [
        {
            id: 'name',
            title: 'Profile name',
            desc: user?.displayName ? user.displayName : 'No profile name available (Click to add)',
            icon: 'ri-user-3-fill',
            color: '#FFFAD3',
            isClickable: true,
            onClick: () => setIsNameModalOpen(true)
        },
        {
            id: 'address',
            title: 'Address',
            desc: userDbData.address ? userDbData.address : 'This address will used as privacy and only shown on certificate. (Click to add)',
            icon: 'ri-map-pin-2-fill',
            color: '#92e9ff6a',
            isClickable: true,
            onClick: () => { setNewAddress(userDbData.address || ''); setIsAddressModalOpen(true); }
        },
        {
            id: 'email',
            title: 'Email',
            desc: user?.email ? user.email : 'No email available',
            icon: 'ri-mail-fill',
            color: '#ffa15957'
        },
        {
            id: 'id',
            title: 'Profile ID',
            desc: user?.uid ? `My profile ID is ${user.uid}.` : 'No profile ID available',
            icon: 'ri-id-card-fill',
            color: '#97d15073'
        },
        {
            id: 'date',
            title: 'Action date',
            desc: user?.metadata?.creationTime ? `Account created at ${new Date(user.metadata.creationTime).toLocaleDateString()}, Last signed in at ${new Date(user.metadata.lastSignInTime).toLocaleDateString()}` : 'Account activity details unavailable.',
            icon: 'ri-id-card-fill',
            color: '#9464dd57'
        }
    ];

    const settCardData = [
        {
            id: 'language',
            title: 'Language',
            desc: 'Change the system language. Current is "English".',
            icon: 'ri-translate',
            color: '#C5C1C1'
        },
        {
            id: 'theme',
            title: 'Theme',
            desc: 'Change system theme or mode to use bester exprience.',
            icon: 'ri-moon-fill',
            color: '#eaffaf'
        }
    ];

    return (
        <main className="main-content">
            <div className="breadcrumb">
                <h3>Settings</h3>
            </div>

            <div className="tabs-container">
                <div className={`tab-item ${activeTab === 'Account' ? 'active' : ''}`} onClick={() => setActiveTab('Account')}>Account</div>
                <div className={`tab-item ${activeTab === 'Settings' ? 'active' : ''}`} onClick={() => setActiveTab('Settings')}>Settings</div>
            </div>

            <div className="cards-grid">
                {activeTab === 'Account' && accCardData.map((card) => (
                    <div
                        key={card.id}
                        className="settings-card"
                        onClick={card.onClick ? card.onClick : undefined}
                        style={card.isClickable ? { cursor: 'pointer' } : undefined}
                        title={card.isClickable ? `Click to edit ${card.title.toLowerCase()}` : undefined}
                    >
                        <div style={{ background: card.color }} className={`card-icon-wrapper`}>
                            <i className={card.icon}></i>
                        </div>
                        <div className="card-content">
                            <h3 className="card-title">{card.title}</h3>
                            <p className="card-desc" style={{ whiteSpace: 'pre-line' }}>{card.desc}</p>
                        </div>
                    </div>
                ))}
                {activeTab === 'Settings' && settCardData.map((card) => (
                    <div key={card.id} className="settings-card">
                        <div style={{ background: card.color }} className={`card-icon-wrapper`}>
                            <i className={card.icon}></i>
                        </div>
                        <div className="card-content">
                            <h3 className="card-title">{card.title}</h3>
                            <p className="card-desc">{card.desc}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* EDIT PROFILE NAME MODAL */}
            {isNameModalOpen && (
                <div className="modal-backdrop" onClick={() => setIsNameModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
                        <div className="modal-header">
                            <h3>Edit Profile Name</h3>
                            <button className="close-modal-btn" onClick={() => setIsNameModalOpen(false)}>✕</button>
                        </div>
                        <form onSubmit={handleUpdateName}>
                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '8px' }}>New Name</label>
                                <input
                                    type="text"
                                    value={newName}
                                    onChange={(e) => setNewName(e.target.value)}
                                    placeholder="Enter your name"
                                    required
                                    style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ccc' }}
                                />
                            </div>
                            <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button type="button" className="cancel-btn" onClick={() => setIsNameModalOpen(false)} style={{ padding: '8px 16px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
                                <button type="submit" className="primary-btn" disabled={isUpdating} style={{ padding: '8px 16px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                                    {isUpdating ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* EDIT ADDRESS MODAL */}
            {isAddressModalOpen && (
                <div className="modal-backdrop" onClick={() => setIsAddressModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
                        <div className="modal-header">
                            <h3>Edit Address</h3>
                            <button className="close-modal-btn" onClick={() => setIsAddressModalOpen(false)}>✕</button>
                        </div>
                        <form onSubmit={handleUpdateAddress}>
                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '8px' }}>New Address</label>
                                <input
                                    type="text"
                                    value={newAddress}
                                    onChange={(e) => setNewAddress(e.target.value)}
                                    placeholder="Enter your address"
                                    required
                                    style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #ccc' }}
                                />
                            </div>
                            <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button type="button" className="cancel-btn" onClick={() => setIsAddressModalOpen(false)} style={{ padding: '8px 16px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
                                <button type="submit" className="primary-id-btn" disabled={isUpdating} style={{ padding: '8px 16px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                                    {isUpdating ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <nav className="bottom-nav-menu">
                {[
                    { name: 'Home', icon: 'ri-home-3-fill' },
                    { name: 'My courses', icon: 'ri-folder-video-fill' },
                    { name: 'Documents', icon: 'ri-article-fill' },
                    { name: 'Reviews', icon: 'ri-chat-ai-4-fill' },
                    { name: 'Profile', icon: 'ri-user-3-fill' }
                ].map((item) => (
                    <button
                        key={item.name}
                        className={`bottom-nav-item ${activeNav === item.name ? 'active' : ''}`}
                        onClick={() => setActiveNav(item.name)}
                    >
                        <i class={item.icon}></i>
                        <span>{item.name}</span>
                    </button>
                ))}
            </nav>
        </main>
    );
}

export default Setting;